
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MetaDataItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'x-small'
    },
    iconColor: {
      type: String,
      default: 'vanilla-400'
    },
    textColor: {
      type: String,
      default: 'text-vanilla-400'
    },
    textSize: {
      type: String,
      default: 'text-xs md:text-sm'
    },
    spacing: {
      type: String,
      default: 'space-x-1'
    },
    wordBreak: {
      type: String,
      default: 'break-all',
      validator: (value: string) => ['break-normal', 'break-words', 'break-all'].includes(value)
    }
  }
})
